import React, { useState } from 'react';
// Dialog
import InventoryGroupFormDialog from './InventoryGroupFormDialog';

type IProps = {}

const InventoryGroupsCreateButton:React.FC<IProps> = () => {
  const [show, setShow] = useState<boolean>(false);

  const handleShow = () => setShow(true);
  const handleHide = () => setShow(false);

  return (
    <>
      <div className="text-right mb-3">
        <button
          className="btn btn-primary btn-sm"
          type="button"
          onClick={handleShow}
        >Create inventory group</button>
      </div>
      {show ? (
        <InventoryGroupFormDialog
          show={show}
          onHide={handleHide}
        />
      ) : null}
    </>
  )
}

export default InventoryGroupsCreateButton;
